import { LayerSpecification, Map } from 'maplibre-gl';
import { MapSourceId } from '@daisi/models/map';

export const DRIPS_SOURCE_ID: MapSourceId = 'realtime-drips';

export const DRIPS_LAYERS: LayerSpecification[] = [
  {
    id: DRIPS_SOURCE_ID + '_dripsOn',
    type: 'symbol',
    minzoom: 8,
    maxzoom: 20,
    layout: {
      'icon-image': 'drip-on',
      'icon-allow-overlap': false,
      'icon-rotate': ['get', 'bearing'],
      'icon-rotation-alignment': 'map',
    },
    filter: ['any', ['!=', ['get', 'image'], null], ['>', ['length', ['get', 'textLines']], 0]],
    source: DRIPS_SOURCE_ID,
  },
  {
    id: DRIPS_SOURCE_ID + '_dripsOff',
    type: 'symbol',
    minzoom: 13,
    maxzoom: 20,
    layout: {
      'icon-image': 'drip-off',
      'icon-allow-overlap': true,
      'icon-rotate': ['get', 'bearing'],
      'icon-rotation-alignment': 'map',
    },
    filter: ['all', ['==', ['get', 'image'], null], ['==', ['length', ['get', 'textLines']], 0]],
    source: DRIPS_SOURCE_ID,
  },
];

export async function addDripImages(map: Map) {
  const on = await map.loadImage('../assets/icons/drip-on.png');
  map.addImage('drip-on', on.data);
  const off = await map.loadImage('../assets/icons/drip-off.png');
  map.addImage('drip-off', off.data);
}
